<!-- src\components\course\FAQCard.vue -->
<template>
	<div class="faq-card">
		<div class="faq-card__drag-handle" title="Перетащите для изменения порядка">
			<svg class="faq-card__drag-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
				<path d="M8 6H16M8 12H16M8 18H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
			</svg>
		</div>

		<div class="faq-card__content">
			<div class="faq-card__header" @click="toggleExpanded">
				<h4 class="faq-card__question">{{ faq.question }}</h4>
				<div class="faq-card__header-actions">
					<span
						v-if="!faq.is_published"
						class="faq-card__badge faq-card__badge--draft"
					>
						Черновик
					</span>
					<span class="faq-card__expand-icon">
						<svg
							v-if="isExpanded"
							width="14"
							height="14"
							viewBox="0 0 24 24"
							fill="none"
							aria-hidden="true"
						>
							<path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<svg
							v-else
							width="14"
							height="14"
							viewBox="0 0 24 24"
							fill="none"
							aria-hidden="true"
						>
							<path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</span>
				</div>
			</div>

			<div v-if="isExpanded" class="faq-card__body">
				<p class="faq-card__answer">{{ faq.answer }}</p>

				<div class="faq-card__actions">
					<button
						v-if="!faq.is_published"
						class="faq-card__action-btn faq-card__action-btn--publish"
						type="button"
						@click="$emit('toggle-publish', faq)"
					>
						<svg class="faq-card__action-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
							<path d="M5 19L19 5M15 5H19V9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path d="M5 5L9 15L15 9L5 5Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
						</svg>
						Опубликовать
					</button>
					<button
						v-else
						class="faq-card__action-btn faq-card__action-btn--unpublish"
						type="button"
						@click="$emit('toggle-publish', faq)"
					>
						<svg class="faq-card__action-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
							<path d="M3 8L12 3L21 8L12 13L3 8Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
							<path d="M3 8V16L12 21L21 16V8" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
						</svg>
						Снять с публикации
					</button>
					<button
						class="faq-card__action-btn"
						type="button"
						@click="$emit('edit', faq)"
					>
						<svg class="faq-card__action-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
							<path d="M3 21H7L19 9L15 5L3 17V21Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
							<path d="M13 7L17 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
						</svg>
						Редактировать
					</button>
					<button
						class="faq-card__action-btn faq-card__action-btn--delete"
						type="button"
						@click="handleDelete"
					>
						<svg class="faq-card__action-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
							<path d="M4 7H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
							<path d="M9 7V5H15V7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
							<path d="M8 10V18M12 10V18M16 10V18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
						</svg>
						Удалить
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FAQCard',
	props: {
		faq: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			isExpanded: false,
		}
	},
	methods: {
		toggleExpanded() {
			this.isExpanded = !this.isExpanded
		},

		handleDelete() {
			if (
				confirm(
					`Вы уверены, что хотите удалить вопрос "${this.faq.question}"? Это действие нельзя отменить.`
				)
			) {
				this.$emit('delete', this.faq)
			}
		},
	},
}
</script>

<style scoped>
.faq-card {
	display: flex;
	gap: 12px;
	background-color: #ffffff;
	border: 2px solid #e8e8e8;
	border-radius: 12px;
	padding: 16px;
	transition: all 0.3s ease;
}

.faq-card:hover {
	border-color: #0095ec;
	box-shadow: 0 4px 12px rgba(0, 149, 236, 0.15);
}

.faq-card__drag-handle {
	width: 24px;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	color: #636363;
	cursor: grab;
	user-select: none;
	padding-top: 4px;
}

.faq-card__drag-icon {
	flex-shrink: 0;
}

.faq-card__drag-handle:active {
	cursor: grabbing;
}

.faq-card__content {
	flex: 1;
}

.faq-card__header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 12px;
	cursor: pointer;
	user-select: none;
}

.faq-card__question {
	color: #252641;
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	font-weight: 600;
	margin: 0;
	flex: 1;
}

.faq-card__header-actions {
	display: flex;
	align-items: center;
	gap: 8px;
}

.faq-card__badge {
	padding: 4px 12px;
	border-radius: 12px;
	font-family: 'Poppins', Helvetica;
	font-size: 11px;
	font-weight: 500;
}

.faq-card__badge--draft {
	background-color: #fff3cd;
	color: #856404;
}

.faq-card__expand-icon {
	color: #636363;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: transform 0.2s ease;
}

.faq-card__body {
	margin-top: 16px;
	padding-top: 16px;
	border-top: 1px solid #e8e8e8;
}

.faq-card__answer {
	color: #636363;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
	line-height: 1.6;
	margin: 0 0 16px 0;
	white-space: pre-wrap;
}

.faq-card__actions {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.faq-card__action-btn {
	padding: 8px 16px;
	background-color: #f5f5f5;
	border: none;
	border-radius: 6px;
	font-family: 'Poppins', Helvetica;
	font-size: 13px;
	font-weight: 500;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	cursor: pointer;
	transition: all 0.2s ease;
}

.faq-card__action-icon {
	flex-shrink: 0;
}

.faq-card__action-btn:hover {
	background-color: #e8e8e8;
	transform: translateY(-2px);
}

.faq-card__action-btn--publish {
	background-color: #d4edda;
	color: #155724;
}

.faq-card__action-btn--publish:hover {
	background-color: #c3e6cb;
}

.faq-card__action-btn--unpublish {
	background-color: #fff3cd;
	color: #856404;
}

.faq-card__action-btn--unpublish:hover {
	background-color: #ffe8a1;
}

.faq-card__action-btn--delete {
	background-color: #f8d7da;
	color: #721c24;
}

.faq-card__action-btn--delete:hover {
	background-color: #f5c6cb;
}
</style>
